import { Box } from "@mui/material";
import React from "react";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 4
};

interface Props {
    children: JSX.Element
}

export const MyBoxModal = React.forwardRef(({ children }: Props, ref) => (
    <Box sx={style} >
        {children}
    </Box >
))
